import * as _ from 'lodash';

angular.module("tromanWeb").controller('MissionGroupsController', ['stateService', 'tromanServer', function (stateService, tromanServer) {

    this.table = null;
    this.items = null;

    this.$onInit = function () {
        const params = stateService.getParams();
        this.filter = params.filter;
        this.search();
    };

    this.uiOnParamsChanged = function (changed) {
        if (_.has(changed, 'filter')) {
            this.filter = changed.filter;
        }
    };

    this.search = function search() {
        tromanServer.MissionGroups.search({}).then(data => {
            this.error = null;
            this.items = data;
        }).catch(err => {
            this.error = err;
            this.items = null;
        });
    };

    this.filterChanged = function filterChanged() {
        stateService.replaceParams({ filter: this.filter });
    };

}]);
